export default {
    name: 'tests-question-options',
    props: {
        list: {},
        type: {
            type: String,
            default: 'options'
        }
    },
    data() {
        return {
            payload: [],
            isAnotherAnswer: false,
            anotherAnswer: '',
        }
    },
    methods: {
        handleInput(val) {
            if (val === 'options') {
                this.isAnotherAnswer = false;
            } else {
                this.payload = [];
            }
            this.$emit('update-question', this.isAnotherAnswer ?
                {
                    value: this.anotherAnswer,
                    type: 'another',
                } : {
                    type: 'checkbox',
                    ids: [this.payload]
                }
            )
        },
        handleInputText() {
            this.$emit('update-question', {
                value: this.anotherAnswer,
                type: this.type,
            })
        }
    },
    destroyed() {
        this.$emit('update-question', [])
        this.payload = [];
        this.anotherAnswer = '';
    }
}
